import { PremiumBody, PremiumHeader } from "../../Components";
import "./style.scss";
import BackArrow from "../../Assets/images/return.png";
import { Box } from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../Redux/Reducers";
import EditImg from "../../Assets/images/edit-white.png";
import SaveImg from "../../Assets/images/save-white.png";
import { getAllPolicyPages, updateStorePolicyPages } from "../../Redux/Actions";
import { ToastNotifyError, ToastNotifySuccess } from "../../Components/Toast";
import isObjectFilled from "@/Utils/isObjectFilled";
import history from "@/Utils/history";
import { SETTING_PAGE_SUBROUTES } from "@/Constants/setting";

const PolicyEditor = (props: any): JSX.Element => {
  const dispatch = useDispatch();
  const [state, setState] = useState<any>({
    html: "",
    policyData: {},
  });
  const [isSaved, setEditorSaved] = useState(true);
  const { storePolicies, storeId } = useSelector((state: RootState) => ({
    storePolicies: state.commonReducer.storePolicies,
    storeId: state.storeReducer.store.store_id,
  }));

  const onBackHandle = () => {
    props.history.goBack();
  };

  useEffect(() => {
    if (props?.match?.params?.id && storePolicies.length) {
      const policy = storePolicies.find((policy: { page_type: any }) => policy.page_type == props.match.params.id);
      if (!policy) {
        history.push(SETTING_PAGE_SUBROUTES.STORE_POLICIES);
        ToastNotifyError("No such store policy page exists!");
      }
      setState((state: any) => ({
        ...state,
        html: policy.html,
        policyData: policy,
      }));
    } else {
      history.push(SETTING_PAGE_SUBROUTES.STORE_POLICIES);
    }
  }, [props.match]);

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [2, false] }],
          ["bold", "italic", "underline"], // toggled buttons
        ],
      },
    }),
    [],
  );

  if (!state.html?.trim() || !isObjectFilled(state.policyData)) {
    return null;
  }

  const handleEditorChange = (html: any) => {
    setState((state: any) => ({
      ...state,
      html: html,
    }));
  };

  const formats = ["header", "font", "bold", "italic", "underline"];

  const toggleEdit = () => {
    setEditorSaved((s) => !s);
  };

  const saveChanges = () => {
    const payload = {
      store_policy_pages: {
        store_id: storeId,
        page_type: Number(props?.match?.params?.id),
        default: false,
        html: state.html,
        is_active: true,
      },
    };
    dispatch(
      updateStorePolicyPages(payload, (status: boolean) => {
        if (status) {
          toggleEdit();
          dispatch(getAllPolicyPages());
          ToastNotifySuccess("Changes saved successfully");
        } else {
          ToastNotifyError("Error occured while saving");
        }
      }),
    );
  };

  return (
    <div className="tw-h-full  tw-w-full tw-overflow-auto">
      <PremiumHeader noAlertBar>
        <Box className="flex items-center justify-between w-100">
          <Box className="flex items-center" fontSize="22px">
            <img src={BackArrow} width="34" height="34" className="mr3 pointer" onClick={onBackHandle} />
            {state?.policyData?.page_name || ""}
          </Box>
          {!isSaved ? 
            <span className="action-button" onClick={saveChanges}>
              <img width="16px" src={SaveImg} className="mr1" />
              Save Changes
            </span>
           : 
            <span className="action-button" onClick={toggleEdit}>
              <img width="16px" src={EditImg} className="mr1" />
              Edit
            </span>
          }
        </Box>
      </PremiumHeader>
      <PremiumBody customClassName={`editor-container ${isSaved ? "hide-toolbar" : ""}`}>
        <ReactQuill
          readOnly={isSaved}
          theme={"snow"}
          value={state.html}
          bounds={".app"}
          modules={modules}
          formats={formats}
          onChange={handleEditorChange}
        />
      </PremiumBody>
    </div>
  );
};

export default PolicyEditor;
